/* eslint-disable @typescript-eslint/no-explicit-any */
import imagen from "../../../../assets/img/fotos.png";
import { myHeaders } from "../../../../config/axios";
import { URL_API } from "../../../../config/default";
import { CustomToast } from "../../../../utils/custom-toast";

const Imagenes = ({ setForm, form }: any) => {
  const onChange = (e: any) => {
    switch (e.target.name) {
      case "images":
        {
          for (let index = 0; index < e.target.files.length; index++) {
            if (index <= 99 && form.IMAGES.length <= 100) {
              const file = e.target.files[index];
              const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf', 'image/webp'];
              
              if (!allowedTypes.includes(file.type)) {
                return CustomToast({
                  status: 400,
                  msg: "",
                  title: "Tipo de archivo no permitido. Solo se aceptan: JPEG, JPG, PNG, GIF, PDF, WEBP",
                });
              }
              
              if (file.size > 10000000) {
                return CustomToast({
                  status: 400,
                  msg: "",
                  title: "La imagen sobrepaso el peso permitido",
                });
              } else {
                const formdata = new FormData();
                formdata.append("property_id", form.id);
                formdata.append("file[" + index + "]", file);

                const requestOptions = {
                  method: "POST",
                  body: formdata,
                  headers: {
                    Authorization: myHeaders, // Un ejemplo de header de autenticación
                  },
                };

                fetch(`${URL_API}/properties/upload`, requestOptions)
                  .then(async (response) => {
                    const imagesResult = await response.json();
                    const image = {
                      id: imagesResult.data[0].id,
                      url: URL.createObjectURL(file),
                      file: file,
                      image: null,
                      imagetable_type: "",
                      imagetable_id: null,
                      created_at: "",
                    };
                    setForm({
                      ...form,
                      IMAGES: [...form.IMAGES, image],
                    });
                    CustomToast({
                      status: 200,
                      msg: "",
                      title: "Imagen creada con exito",
                    });
                  })
                  .then((result) => console.log(result))
                  .catch((error) => console.error(error));
              }
            }
          }
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "image-delete":
        {
          delete form.IMAGES[value.index];
          const images = form.IMAGES.filter((i: any) => i! != null);
          setForm({
            ...form,
            IMAGES: images,
          });

          const formdata = new FormData();
          formdata.append("id", value.id);
          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/properties/upload-destroy`, requestOptions)
            .then(async () => {
              CustomToast({
                status: 200,
                msg: "",
                title: "Imagen eliminada con exito",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className={`grid   gap-10 py-5 px-5 ${form.IMAGES.length > 6 ? 'lg:grid-cols-1' : 'lg:grid-cols-2'}`}>
      <div>
        <span className="font-bold text-primary mb-2 block">
          Agregá algunas fotos
        </span>
        <div className="grid grid-cols-1 gap-5">
          <span>
            Para comenzar, vas a necesitar 5 fotos. Podés agregar otras más o
            hacer cambios más adelante.
          </span>

          <label className="border-dashed px-5 py-5 border border-black items-center ">
            <img src={imagen} alt="" className="mx-auto" width={200} />
            <div className="text-center my-4">
              <span className="block font-bold">
                Seleccioná por lo menos 5 fotos
              </span>
              <span className="border border-black border-s-0 border-t-0 border-e-0">
                Subilas desde tu dispositivo
              </span>
            </div>
            <input
              className="hidden"
              type="file"
              name="images"
              accept="image/*"
              onChange={(event) => onChange(event)}
            />
          </label>
        </div>
      </div>
      <div>
        <div className="grid grid-cols-2 gap-3">
          {form.IMAGES.length > 0
            ? form.IMAGES.map((img: any, index: number) => {
                return (
                  <label
                    key={index}
                    className="
                group
                cursor-pointer 
                overflow-hidden 
                p-0 
                h-[300px]
                hover:opacity-[0.9]
                hover:scale-110 transition-transform duration-300
                relative
                "
                    title="Eliminar"
                    style={{ borderRadius: "20px" }}
                  >
                    <img
                      src={img.url}
                      alt=""
                      className="w-full h-full"
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                    <span
                      className="absolute text-white opacity-[0] 
                group-hover:opacity-[1]"
                      style={{
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 4,
                      }}
                    >
                      Eliminar
                    </span>
                    <button
                      className="hidden"
                      name="image-delete"
                      onClick={(event) =>
                        onClick(event, { index: index, id: img.id })
                      }
                    ></button>
                  </label>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default Imagenes;
